import React, { useEffect, useState } from "react";
import CustomSelect from "../form/CustomSelect";
import SingleCalendarDateRangePicker from "../form/SingleCalendarDateRangePicker";
import { getStatuses, plansResource } from "../../helpers/configRoutes/backend_helper";
import "react-datepicker/dist/react-datepicker.css";

const FiltersPagination = ({
    meta,
    children,
    filters,
    setFilters,
    showFilters,
    statusModel = "Subscription",
    showDateFilter = true,
    showPlanFilter = true,
    showStatusFilter = true,
}) => {
    const [statuses, setStatuses] = useState([]);
    const [plans, setPlans] = useState([]);

    useEffect(() => {
        if (!showFilters) return;

        const getFilters = async () => {
            const requests = [];

            if (showPlanFilter) {
                requests.push(plansResource("get", { params: { select: true } }));
            } else {
                requests.push(Promise.resolve(null));
            }

            if (showStatusFilter) {
                requests.push(getStatuses({ params: { model: statusModel } }));
            } else {
                requests.push(Promise.resolve(null));
            }

            const [plansResponse, statusesResponse] = await Promise.all(requests);

            if (plansResponse?.status) setPlans(plansResponse.plans);
            if (statusesResponse?.status) setStatuses(statusesResponse.statuses);
        };

        getFilters();
    }, [showFilters, statusModel, showPlanFilter, showStatusFilter]);

    const resetFilters = () => {
        setFilters({
            ...filters,
            search: "",
            ...(showPlanFilter ? { plan_id: "" } : {}),
            ...(showStatusFilter ? { status_id: "" } : {}),
            startDate: null,
            endDate: null,
            page: 1
        });
    };

    return (
        <>
            {showFilters && (
                <div className="flex w-full mb-6 gap-4">
                    <div className="flex items-center bg-mts-button-gray border rounded-lg p-3 space-x-4 w-2/3 relative flex-wrap">
                        {showDateFilter && (
                            <div className="min-w-[240px] max-w-[320px] w-full">
                                <SingleCalendarDateRangePicker
                                    holder="Date range"
                                    filters={filters}
                                    setFilters={setFilters}
                                    valueStart={filters.startDate}
                                    valueEnd={filters.endDate}
                                    className="mt-0 bg-white"
                                />
                            </div>
                        )}

                        {showPlanFilter && (
                            <CustomSelect
                                className="border-none"
                                options={plans}
                                holder="Subscription"
                                value={filters.plan_id}
                                onChange={e =>
                                    setFilters({ ...filters, plan_id: e.target.value, page: 1 })
                                }
                            />
                        )}

                        {showStatusFilter && (
                            <CustomSelect
                                className="border-none"
                                options={statuses}
                                holder="Status"
                                value={filters.status_id}
                                onChange={e =>
                                    setFilters({ ...filters, status_id: e.target.value, page: 1 })
                                }
                            />
                        )}

                        <button
                            onClick={resetFilters}
                            className="flex items-center space-x-1 text-mts-red"
                            type="button"
                        >
                            <i className="fa fa-repeat"></i>
                            <span>Reset</span>
                        </button>
                    </div>

                    <div className="relative w-1/3 p-4">
                        <input
                            type="text"
                            placeholder="Search"
                            value={filters.search}
                            onChange={e =>
                                setFilters({ ...filters, search: e.target.value, page: 1 })
                            }
                            className="pl-10 pr-4 py-2 w-full bg-gray-200 rounded-full focus:outline-none focus:ring-2 focus:ring-purple-500"
                        />
                        <i className="fa fa-search absolute left-7 top-7 text-gray-400"></i>
                    </div>
                </div>
            )}

            {children}

            <div className="flex items-center justify-between py-2">
                <div className="text-gray-500">
                    Showing <b>{meta.from}-{meta.to}</b> of <b>{meta.total}</b>
                </div>

                <div className="flex space-x-1">
                    <button
                        disabled={filters.page === 1}
                        onClick={() => setFilters({ ...filters, page: filters.page - 1 })}
                        className="w-8 h-8 border rounded hover:bg-gray-200 disabled:opacity-50"
                        type="button"
                    >
                        ‹
                    </button>

                    <button
                        disabled={meta.last_page === filters.page}
                        onClick={() => setFilters({ ...filters, page: filters.page + 1 })}
                        className="w-8 h-8 border rounded hover:bg-gray-200 disabled:opacity-50"
                        type="button"
                    >
                        ›
                    </button>
                </div>
            </div>
        </>
    );
};

export default FiltersPagination;
